export const THUMBNAILS_TYPES = {
    BACKGROUND_COLOR: "BACKGROUND_COLOR",
    BACKGROUND_IMAGE: "BACKGROUND_IMAGE"
};
